import heroku from "../assets/heroku.png";
import htmlcss from "../assets/htmlcss.png";
import react from "../assets/react.png";
import nodejs from "../assets/nodejs.png";
import javascript from "../assets/javascript.png";
import netlify from "../assets/netlify.png";

const databank = [
  {
    id: 1,
    name: "heroku",
    image: heroku,
    selected: false,
    closed: false,
  },
  {
    id: 2,
    name: "htmlcss",
    image: htmlcss,
    selected: false,
    closed: false,
  },
  {
    id: 3,
    name: "react",
    image: react,
    selected: false,
    closed: false,
  },
  {
    id: 4,
    name: "javascript",
    image: javascript,
    selected: false,
    closed: false,
  },
  {
    id: 5,
    name: "netlify",
    image: netlify,
    selected: false,
    closed: false,
  },
  {
    id: 6,
    name: "nodejs",
    image: nodejs,
    selected: false,
    closed: false,
  },
  {
    id: 7,
    name: "heroku",
    image: heroku,
    selected: false,
    closed: false,
  },
  {
    id: 8,
    name: "htmlcss",
    image: htmlcss,
    selected: false,
    closed: false,
  },
  {
    id: 9,
    name: "react",
    image: react,
    selected: false,
    closed: false,
  },
  {
    id: 10,
    name: "javascript",
    image: javascript,
    selected: false,
    closed: false,
  },
  {
    id: 11,
    name: "netlify",
    image: netlify,
    selected: false,
    closed: false,
  },
  {
    id: 12,
    name: "nodejs",
    image: nodejs,
  },
];
export default databank;
